import { useEffect, useMemo } from "react";
// material
import { styled } from "@material-ui/core/styles";
import { CircularProgress } from "@material-ui/core";
//
// import Logo from "./Logo";

// ----------------------------------------------------------------------

const RootStyle = styled("div")(({ theme }) => ({
  height: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  backgroundColor: "#ebebeb",
}));


export default function LoadingScreen({ ...other }) {
  return (
    <RootStyle {...other}>
      <CircularProgress />
    </RootStyle>
  );
}
